export default __webpack_public_path__ + "static/media/Applause.786afca8.mp3";